import LineInterface from 'app/interfaces/LineInterface';
import {hasOpenedNested, isOpened} from 'app/lines/line_helpers';

export const isActiveLine = (line: LineInterface): boolean => {
    const {color} = line;
    return isOpened(color) || hasOpenedNested(color);
};
